<template>
	<textarea class="redactor-wysiwyg tall-height" v-model="redactorValue"></textarea>
</template>

<script>

// Redactor
require('@/libraries/redactor/redactor.min');
require('@/libraries/redactor/video/video.min');
require('@/libraries/redactor/fullscreen/fullscreen.min');
require('@/libraries/redactor/inlinestyle/inlinestyle.min');

import { mapGetters } from 'vuex';
import REDACTOR from '@/constants/redactor';

export default {

	props: ['value'],

	data() {
		return {
			redactorValue: this.value,
			redactor: null,
		};
	},

	computed: mapGetters(['currentAccount']),

	mounted: function() {
		// $R is defined globally
		// eslint-disable-next-line no-undef
		this.redactor = new $R(this.$el, {
			plugins: this.getPlugins(),
			linkNewTab: true,
			buttons: this.getButtons(),
			breakline: false,
			callbacks: {
				changed: (html) => {
					this.redactorValue = html;
					this.$emit('input', this.redactorValue);
				},
			},
		});
	},

	watch: {

		redactorValue(newValue) {
			this.$emit('input', newValue);
		},

	},

	methods: {

		getButtons() {
			let buttons = REDACTOR.settings.product.buttons;
			if ((this.$root.isSuperAdmin || this.currentAccount.is_advanced) && buttons.indexOf('html') === -1) {
				buttons = [ ...buttons, 'html' ];
			}

			return buttons;
		},

		getPlugins() {
			return REDACTOR.settings.product.plugins;
		},

	},
};

</script>
